import React from 'react';
import { Form, Input, Tooltip, Button, Select } from 'antd';
import { ReactSVG } from 'react-svg';

export const PeddlerCarrier = ({ done, carrierIntegration, handleUpdate, carriers }) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    form.resetFields();
    done();
  };

  const isNew = carrierIntegration === undefined;

  const submit = (values) => {
    if (isNew) {
      // do something for new integration
      handleUpdate({
        name: values.name,
        carrierService: 'PEDDLER',
        carrierName: 'PEDDLER',
        config: {
          serviceLevel: values.serviceLevel,
        },
        carrierId: values.carrier,
      });
    } else {
      const updatedCarrier = {
        ...carrierIntegration,
        name: values.name,
        config: {
          serviceLevel: values.serviceLevel,
        },
        carrierId: values.carrier,
      };
      handleUpdate(updatedCarrier);
    }
    form.resetFields();
    done({ refetch: true });
  };

  const serviceLevelOptions = [
    { value: 'NEXT_DAY_48', label: 'next_day_48' },
    { value: 'NEXT_DAY_60', label: 'next_day_60' },
    { value: 'SAME_DAY_24', label: 'same_day_24' },
    { value: 'SAME_DAY_SAT_24', label: 'same_day_sat_24' },
    { value: 'SAME_DAY_SUN_24', label: 'same_day_sun_24' },
    { value: 'EXPRESS_0900', label: 'express_0900' },
    { value: 'EXPRESS_1030', label: 'express_1030' },
    { value: 'EXPRESS_1200', label: 'express_1200' },
    { value: 'EXPRESS_1700', label: 'express_1700' },
    { value: 'EXPRESS_1800', label: 'express_1800' },
    { value: 'EXPRESS_2200', label: 'express_2200' },
    { value: 'EXPRESS_SAT', label: 'express_sat' },
    { value: 'EXPRESS_SUN', label: 'express_sun' },
    { value: 'INSTANT_02', label: 'instant_02' },
  ];

  return (
    <div className="RoutePlanForm">
      <Form form={form} onFinish={submit} layout="vertical" requiredMark={false} colon={false}>
        <Form.Item
          label="Carrier"
          value={isNew ? '' : carrierIntegration?.carrierId}
          initialValue={isNew ? '' : carrierIntegration?.carrierId}
          name="carrier"
          rules={[{ required: true, message: 'Required' }]}
        >
          <Select
            className="select"
            options={carriers?.map((carrier) => ({ label: carrier.name, value: carrier.id }))}
            defaultValue={isNew ? '' : carrierIntegration?.carrierId}
            style={{ minWidth: '100px' }}
          />
        </Form.Item>

        <Form.Item
          label="Name"
          value={isNew ? '' : carrierIntegration?.name}
          initialValue={isNew ? '' : carrierIntegration?.name}
          name="name"
          rules={[{ required: true, message: 'Required' }]}
        >
          <Input placeholder="Give this carrier integration a name" size="large" />
        </Form.Item>

        <Form.Item
          label="What service level do you want to have?"
          value={isNew ? '' : carrierIntegration?.config?.serviceLevel}
          initialValue={isNew ? '' : carrierIntegration?.config?.serviceLevel}
          name="serviceLevel"
          rules={[{ required: true, message: 'Required' }]}
        >
          <Select
            className="select-small"
            options={serviceLevelOptions}
            defaultValue={isNew ? '' : carrierIntegration?.config?.serviceLevel}
            style={{ minWidth: '100px' }}
          />
        </Form.Item>

        <div className="FormFooter">
          <Button key="cancel" size="small" onClick={handleCancel}>
            Cancel
          </Button>
          <Tooltip
            title="By enabling the veloyd integration, you can add the integration to delivery areas, just like any other carrier."
            placement="right"
          >
            <Button key="confirm" type="primary" size="small" htmlType="submit">
              {isNew ? 'Add' : 'Update'} integration
              <ReactSVG className="icon" src="/icons/done.svg" />
            </Button>
          </Tooltip>
        </div>
      </Form>
    </div>
  );
};
